import { KPICard } from "@/components/dashboard/KPICard";
import { SpendingChart } from "@/components/dashboard/SpendingChart";
import { TrendsChart } from "@/components/dashboard/TrendsChart";
import { AlertsCard } from "@/components/dashboard/AlertsCard";
import { TransactionsTable } from "@/components/dashboard/TransactionsTable";
import { mockKPIs } from "@/lib/mockData";

export default function Dashboard() {
  return (
    <div className="space-y-6">
      {/* Page Header */}
      <div className="flex flex-col space-y-2">
        <h1 className="text-3xl font-bold tracking-tight">Dashboard</h1>
        <p className="text-muted-foreground">
          Welcome back! Here's your financial overview for this month.
        </p>
      </div>

      {/* KPI Cards */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {mockKPIs.map((kpi, index) => (
          <KPICard
            key={index}
            title={kpi.label}
            value={kpi.value}
            change={kpi.change}
            trend={kpi.trend}
            icon={kpi.icon}
          />
        ))}
      </div>

      {/* Charts Row */}
      <div className="grid grid-cols-1 lg:grid-cols-5 gap-6">
        <SpendingChart />
        <TrendsChart />
      </div>

      {/* Alerts and Transactions Row */}
      <div className="grid grid-cols-1 lg:grid-cols-5 gap-6">
        <AlertsCard />
        <TransactionsTable />
      </div>

      {/* Future Insights */}
      <div className="grid grid-cols-1 gap-6">
        <div className="flex items-center justify-center rounded-lg border border-dashed border-border bg-muted/20 p-8">
          <div className="text-center text-muted-foreground">
            <div className="text-2xl mb-2">📈</div>
            <p className="text-sm">More insights coming soon...</p>
          </div>
        </div>
      </div>
    </div>
  );
}